import * as React from 'react';
export const PopoverContext = React.createContext({});
//# sourceMappingURL=PopoverContext.js.map